<template>
  <div class="pc-home">
    <section class="pc-container hero-panel">
      <div
        class="category-box"
        @mouseleave="closeCategoryMenu"
      >
        <div
          class="category-title"
          :class="{ active: categoryMenuVisible && !activeNavigation }"
          @mouseenter="showAllCategories"
        >
          <span>全部产品分类</span>
          <img :src="iconRight" alt="">
        </div>
        <div class="category-list">
          <button
            v-for="item in categoryNavigations"
            :key="item.id"
            class="category-item"
            :class="{ active: activeNavigation && activeNavigation.id === item.id }"
            @mouseenter="showNavigation(item)"
            @click="goNavigation(item)"
          >
            <span>{{ item.name }}</span>
            <img :src="iconRight" alt="">
          </button>
        </div>

        <div
          v-show="categoryMenuVisible"
          class="category-mega-menu"
          :class="{ single: activeNavigation }"
        >
          <div v-for="navigation in displayedNavigations" :key="'mega-' + navigation.id" class="category-navigation-group">
            <div v-for="item in navigation.categories" :key="'category-' + item.id" class="category-group">
              <button class="category-group-title" @click="goCategory(item)">{{ item.name }}</button>
              <div v-if="item.children && item.children.length" class="category-kind-list">
                <button v-for="kind in item.children" :key="kind.id" @click="goCategory(item, kind)">
                  {{ kind.name }}
                </button>
              </div>
              <span v-else class="category-empty">暂无下级种类</span>
            </div>
          </div>
        </div>
      </div>

      <div class="banner">
        <img
          v-for="(poster, index) in posters"
          :key="poster + index"
          :src="poster"
          :class="{ active: index === activePosterIndex }"
          alt="商城海报"
        >
        <div v-if="posters.length > 1" class="banner-dots">
          <button
            v-for="(poster, index) in posters"
            :key="'dot' + poster + index"
            :class="{ active: index === activePosterIndex }"
            @click="selectPoster(index)"
          ></button>
        </div>
      </div>

      <div class="member-card">
        <div v-if="memberUser" class="logged-member">
          <h3>您好！ <b>{{ memberPhone }}</b></h3>
          <button @click="goMember">会员中心</button>
        </div>
        <template v-else>
          <h3>您好！欢迎来到{{ companyName }}~</h3>
          <div class="member-actions">
            <button class="primary" @click="goLogin">注册</button>
            <button @click="goLogin">登录</button>
          </div>
        </template>
        <div class="member-separator"></div>
        <div class="news-title">
          <span>公司新闻</span>
          <a @click="goNews">更多 <img :src="iconRight" alt=""></a>
        </div>
        <ul>
          <li v-for="item in featuredNews" :key="item.id" @click="goNewsDetail(item)">
            <span>精选</span>{{ item.title }}
          </li>
        </ul>
        <div class="quick-grid">
          <button v-for="item in quickLinks" :key="item.label" @click="item.action && item.action()">
            <img :src="item.icon" alt="">
            <span>{{ item.label }}</span>
          </button>
        </div>
      </div>
    </section>

    <section class="pc-container hot-section">
      <div class="home-section-title">
        <div>
          <h2>热销榜单</h2>
          <span>热卖爆款 现货直降!</span>
        </div>
        <a @click="goProducts">查看更多 <img :src="iconRight" alt=""></a>
      </div>
      <div class="hot-content">
        <div class="hot-list">
          <div v-for="(item, index) in hotProducts" :key="item.id" class="hot-item" @click="goProductDetail(item)">
            <span :class="{ fire: isHotProduct(index) }">{{ isHotProduct(index) ? '热' : '' }}</span>
            <div class="hot-product-info">
              <b v-if="index === 1">{{ productTitle(item) }}</b>
              <em v-else>{{ productTitle(item) }}</em>
              <small v-if="productType(item)">产品类型：{{ productType(item) }}</small>
              <small>品牌：{{ productBrand(item) }}</small>
            </div>
          </div>
        </div>
        <div class="inquiry-card">
          <div class="inquiry-head">
            <div class="inquiry-icon">
              <img :src="iconInquiry" alt="">
            </div>
            <div>
              <strong>在线找料</strong>
            </div>
          </div>
          <button @click="goSourcing">在线找料</button>
        </div>
      </div>
    </section>

    <section class="pc-container info-grid">
      <div class="info-card">
        <div class="home-section-title compact">
          <h2>行业资讯</h2>
          <a @click="goNews">查看更多 <img :src="iconRight" alt=""></a>
        </div>
        <div class="info-body">
          <div class="feature-news" v-if="industryNewsMain" @click="goNewsDetail(industryNewsMain)">
            <img :src="industryNewsMain.coverImage" :alt="industryNewsMain.title">
            <h3>{{ industryNewsMain.title }}</h3>
            <p>{{ industryNewsMain.summary }}</p>
          </div>
          <ol class="rank-list">
            <li v-for="(item, index) in industryNewsList" :key="item.id" @click="goNewsDetail(item)">
              <span>{{ index + 1 }}</span>
              <b>{{ item.title }}</b>
            </li>
          </ol>
        </div>
      </div>

      <div class="info-card">
        <div class="home-section-title compact">
          <h2>视频中心</h2>
          <a @click="goVideos">查看更多 <img :src="iconRight" alt=""></a>
        </div>
        <div class="info-body video-body">
          <div class="feature-news" v-if="mainVideo" @click="openVideo(mainVideo)">
            <img :src="mainVideo.coverImage" :alt="mainVideo.title">
            <h3>{{ mainVideo.title }}</h3>
            <p>{{ mainVideo.summary }}</p>
          </div>
          <ol class="rank-list video-list">
            <li v-for="(item, index) in videoList" :key="item.id" @click="openVideo(item)">
              <span>{{ index + 1 }}</span>
              <b>{{ item.title }}</b>
              <button><img :src="iconPlay" alt=""></button>
            </li>
          </ol>
        </div>
      </div>
    </section>

    <section v-if="directBrands.length || agentBrands.length" class="pc-container brand-section">
      <div class="brand-block">
        <div class="section-head">
          <h2>原厂直销</h2>
          <span>全程可溯</span>
          <span>质量保证</span>
        </div>
        <div class="brand-grid">
          <div v-for="item in directBrands" :key="item" class="brand-card">{{ item }}</div>
        </div>
      </div>
      <div class="brand-block">
        <div class="section-head">
          <h2>授权合作</h2>
          <span>数据平台</span>
          <span>透明高效</span>
        </div>
        <div class="brand-grid">
          <div v-for="item in agentBrands" :key="item" class="brand-card">{{ item }}</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import { getPcCategoryNavigation, getPcMallSettings, getPcProductList, getPcPublicNewsList, getPcPublicVideoList } from '@/api/pc'
  import commerce from '@/utils/pcCommerce'
  import { productTitle, productType, productBrand } from '@/utils/pcProductDisplay'
  import { buildPcDetailPath } from '@/utils/pcRouteCode'
  import pcAuth from '@/utils/pcAuth'

  const pcIcons = {
    right: require('@/assets/icons/pc/chevron-right.svg'),
    play: require('@/assets/icons/pc/play.svg'),
    inquiry: require('@/assets/icons/pc/inquiry.svg'),
    order: require('@/assets/icons/pc/order.svg'),
    coupon: require('@/assets/icons/pc/coupon.svg'),
    invoice: require('@/assets/icons/pc/invoice.svg'),
    gift: require('@/assets/icons/pc/gift.svg'),
    bom: require('@/assets/icons/pc/bom.svg'),
    stock: require('@/assets/icons/pc/stock.svg'),
    wallet: require('@/assets/icons/pc/wallet.svg')
  }

  export default {
    name: 'PcHome',
    data() {
      return {
        categoryNavigations: [],
        categoryMenuVisible: false,
        activeNavigation: null,
        setting: {},
        posters: [],
        activePosterIndex: 0,
        posterTimer: null,
        news: [],
        videos: [],
        memberUser: pcAuth.getToken() ? pcAuth.getUser() : null,
        hotProducts: [],
        iconRight: pcIcons.right,
        iconPlay: pcIcons.play,
        iconInquiry: pcIcons.inquiry,
        quickLinks: [
          { label: '我的订单', icon: pcIcons.order, action: () => this.$router.push('/pc/member/orders') },
          { label: '优惠券', icon: pcIcons.coupon, action: () => this.$router.push('/pc/member/coupons') },
          { label: '会员资料', icon: pcIcons.invoice, action: () => this.$router.push('/pc/member/profile') },
          { label: '积分商城', icon: pcIcons.gift, action: () => this.$router.push('/pc/points') },
          { label: 'BOM配单', icon: pcIcons.bom, action: this.goBom },
          { label: '联系客服', icon: pcIcons.inquiry, action: this.contactService },
          { label: '收货地址', icon: pcIcons.stock, action: () => this.$router.push('/pc/member/addresses') },
          { label: '我的兑换', icon: pcIcons.wallet, action: () => this.$router.push('/pc/member/points') }
        ],
        directBrands: [],
        agentBrands: []
      }
    },
    created() {
      this.loadHome()
    },
    mounted() {
      this.resetPosterCarousel()
    },
    beforeDestroy() {
      this.stopPosterCarousel()
    },
    computed: {
      activePoster() {
        return this.posters && this.posters.length ? this.posters[this.activePosterIndex] : ''
      },
      featuredNews() {
        return this.news.slice(0, 4)
      },
      industryNewsMain() {
        return this.news[0] || null
      },
      industryNewsList() {
        return this.news.slice(0, 8)
      },
      mainVideo() {
        return this.videos[0] || null
      },
      videoList() {
        return this.videos.slice(0, 8)
      },
      displayedNavigations() {
        return this.activeNavigation ? [this.activeNavigation] : this.categoryNavigations
      },
      memberPhone() {
        const user = this.memberUser || {}
        return user.maskedPhone || pcAuth.maskPhone(user.registeredPhone || user.phone)
      },
      companyName() { return this.setting.companyName || '锐高科技' }
    },
    methods: {
      productTitle,
      productType,
      productBrand,
      goSourcing() {
        this.$router.push('/pc/sourcing')
      },
      goLogin() {
        this.$router.push({ path: '/pc/login', query: { redirect: this.$route.fullPath } })
      },
      goMember() {
        this.$router.push('/pc/member')
      },
      loadHome() {
        getPcCategoryNavigation().then(data => {
          this.categoryNavigations = Array.isArray(data) ? data : []
        }).catch(() => {
          this.categoryNavigations = []
        })
        getPcMallSettings().then(data => {
          this.setting = data || {}
          this.posters = commerce.normalizePosterImages(this.setting.posterImages)
          this.directBrands = this.parseStringList(this.setting.directBrandsJson)
          this.agentBrands = this.parseStringList(this.setting.agentBrandsJson)
          this.resetPosterCarousel()
        }).catch(() => {
          this.setting = {}
          this.posters = []
          this.directBrands = []
          this.agentBrands = []
          this.resetPosterCarousel()
        })
        getPcPublicNewsList({ page: 1, pageSize: 8 }).then(data => {
          const records = data && data.records ? data.records : []
          this.news = records.map(commerce.normalizePcNews).slice(0, 8)
        }).catch(() => {
          this.news = []
        })
        getPcPublicVideoList({ page: 1, pageSize: 8 }).then(data => {
          const records = data && data.records ? data.records : []
          this.videos = records.map(commerce.normalizePcVideo).slice(0, 8)
        }).catch(() => {
          this.videos = []
        })
        getPcProductList({ page: 1, pageSize: 15 }).then(data => {
          const records = data && data.records ? data.records : []
          this.hotProducts = records.map(item => ({
            ...item,
            id: item.id || item.productId
          })).filter(item => item.id)
        }).catch(() => {
          this.hotProducts = []
        })
      },
      goProducts() {
        this.$router.push('/pc/products')
      },
      goProductDetail(item) {
        this.$router.push(buildPcDetailPath('product', item.id))
      },
      goBom() {
        this.$router.push('/pc/bom')
      },
      goNews() {
        this.$router.push('/pc/news')
      },
      goVideos() {
        this.$router.push('/pc/videos')
      },
      parseStringList(value) {
        if (Array.isArray(value)) return value.map(item => String(item || '').trim()).filter(Boolean)
        try {
          const parsed = JSON.parse(value || '[]')
          return Array.isArray(parsed) ? parsed.map(item => String(item || '').trim()).filter(Boolean) : []
        } catch (error) {
          return String(value || '').split(/[\n,，]/).map(item => item.trim()).filter(Boolean)
        }
      },
      contactService() {
        const qrCode = this.setting.wechatQrCode ? commerce.normalizeAssetPath(this.setting.wechatQrCode) : ''
        const phone = this.setting.servicePhone || ''
        const content = this.setting.customerServiceText || (phone ? `客服电话：${phone}` : '后台暂未配置客服联系方式')
        this.$info({
          title: '联系客服',
          width: 420,
          content: h => h('div', [
            h('p', content),
            phone ? h('p', `客服电话：${phone}`) : null,
            qrCode ? h('img', { attrs: { src: qrCode, alt: '企业微信客服二维码' }, style: { width: '220px', display: 'block', margin: '16px auto 0' } }) : null
          ].filter(Boolean))
        })
      },
      goNewsDetail(item) {
        this.$router.push(buildPcDetailPath('news', item.id))
      },
      isHotProduct(index) {
        return index < 6
      },
      openVideo(item) {
        this.$router.push(buildPcDetailPath('video', item.id))
      },
      selectPoster(index) {
        this.activePosterIndex = index
        this.resetPosterCarousel()
      },
      resetPosterCarousel() {
        this.stopPosterCarousel()
        this.activePosterIndex = Math.min(this.activePosterIndex, Math.max(this.posters.length - 1, 0))
        if (this.posters.length <= 1) {
          return
        }
        this.posterTimer = window.setInterval(() => {
          this.activePosterIndex = (this.activePosterIndex + 1) % this.posters.length
        }, 4500)
      },
      stopPosterCarousel() {
        if (this.posterTimer) {
          window.clearInterval(this.posterTimer)
          this.posterTimer = null
        }
      },
      showAllCategories() {
        this.activeNavigation = null
        this.categoryMenuVisible = true
      },
      showNavigation(item) {
        this.activeNavigation = item
        this.categoryMenuVisible = true
      },
      closeCategoryMenu() {
        this.categoryMenuVisible = false
        this.activeNavigation = null
      },
      goNavigation(item) {
        this.$router.push({
          path: '/pc/products',
          query: {
            ...(item.groupId ? { groupId: item.groupId } : { categoryId: item.categoryId }),
            title: item.name
          }
        })
      },
      goCategory(item, child) {
        this.$router.push({
          path: '/pc/products',
          query: {
            categoryId: item.id,
            ...(child ? { subCategoryId: child.id } : {}),
            title: child ? child.name : item.name
          }
        })
      }
    }
  }
</script>

<style scoped>
  .pc-home {
    padding: 18px 0 44px;
  }

  .hero-panel {
    display: grid;
    grid-template-columns: 260px 1fr 260px;
    gap: 12px;
    padding: 12px;
    background: #fff;
    border-radius: 8px;
  }

  .category-box {
    position: relative;
    z-index: 5;
    height: 440px;
    padding: 10px 14px;
    border-radius: 8px;
    background: #f7f8fb;
  }

  .category-title {
    margin-bottom: 12px;
    font-size: 16px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 4px;
    transition: color .2s ease, background-color .2s ease;
  }

  .category-title.active {
    padding: 6px 8px;
    margin: -6px -8px 6px;
    background: #1684ff;
    color: #fff;
  }

  .category-list {
    height: 396px;
    overflow-y: auto;
    scrollbar-width: thin;
  }

  .category-title img,
  .news-title img,
  .home-section-title a img,
  .welfare img {
    width: 14px;
    height: 14px;
    object-fit: contain;
  }

  .category-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 31px;
    border: 0;
    background: transparent;
    text-align: left;
    font-size: 14px;
    cursor: pointer;
  }

  .category-item img {
    width: 12px;
    height: 12px;
    opacity: 0;
  }

  .category-item:hover,
  .category-item.active {
    color: #1684ff;
    background: #eaf4ff;
  }

  .category-item:hover img,
  .category-item.active img {
    opacity: 1;
  }

  .category-mega-menu {
    position: absolute;
    top: 0;
    left: 100%;
    width: 940px;
    height: 440px;
    padding: 22px 24px;
    border: 1px solid #dce8f7;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 12px 30px rgba(15, 54, 96, .18);
    box-sizing: border-box;
    overflow-y: auto;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    align-content: start;
    gap: 22px 28px;
  }

  .category-mega-menu.single {
    width: 520px;
    height: auto;
    min-height: 120px;
    grid-template-columns: minmax(0, 1fr);
  }

  .category-group {
    min-width: 0;
  }

  .category-navigation-group {
    min-width: 0;
    display: grid;
    align-content: start;
    gap: 22px;
  }

  .category-group-title {
    width: 100%;
    padding: 0 0 9px;
    border: 0;
    border-bottom: 1px solid #dce8f7;
    background: transparent;
    color: #172033;
    text-align: left;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
  }

  .category-group-title:hover {
    color: #1684ff;
  }

  .category-kind-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 14px;
    margin-top: 10px;
  }

  .category-kind-list button {
    padding: 0;
    border: 0;
    background: transparent;
    color: #5f6b7a;
    line-height: 24px;
    cursor: pointer;
  }

  .category-kind-list button:hover {
    color: #1684ff;
  }

  .category-empty {
    display: block;
    margin-top: 10px;
    color: #8a8f99;
    font-size: 13px;
  }

  .banner {
    position: relative;
    height: 440px;
    border-radius: 8px;
    overflow: hidden;
    background: #f3f4f6;
  }

  .banner img {
    position: absolute;
    inset: 0;
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0;
    transition: opacity .35s ease;
  }

  .banner img.active {
    opacity: 1;
  }

  .banner-dots {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 14px;
    display: flex;
    justify-content: center;
    gap: 8px;
    z-index: 2;
  }

  .banner-dots button {
    width: 18px;
    height: 4px;
    padding: 0;
    border: 0;
    border-radius: 4px;
    background: rgba(255, 255, 255, .72);
    cursor: pointer;
  }

  .banner-dots button.active {
    width: 28px;
    background: #1684ff;
  }

  .member-card {
    height: 440px;
    padding: 18px;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    background: #eef8ff;
  }

  .member-card h3 {
    margin: 0 0 14px;
    font-size: 16px;
  }

  .member-actions {
    display: flex;
    justify-content: center;
    gap: 14px;
  }

  .member-actions button {
    width: 82px;
    height: 28px;
    border: 0;
    border-radius: 4px;
    background: #ff5a00;
    color: #fff;
  }

  .member-actions .primary {
    background: #1684ff;
  }

  .member-separator { height: 1px; margin: 14px 0; background: #dce8f2; }

  .logged-member { padding: 3px 0 1px; text-align: center; }

  .logged-member h3 { color: #1f2937; line-height: 28px; }

  .logged-member button {
    width: 128px;
    height: 30px;
    border: 0;
    border-radius: 4px;
    background: #ff5a00;
    color: #fff;
    cursor: pointer;
  }

  .news-title {
    display: flex;
    justify-content: space-between;
    font-weight: 700;
  }

  .news-title a,
  .home-section-title a {
    display: inline-flex;
    align-items: center;
    gap: 3px;
  }

  .member-card ul {
    padding: 0;
    margin: 8px 0 12px;
    list-style: none;
    line-height: 26px;
    font-size: 12px;
  }

  .member-card li {
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .member-card li span {
    display: inline-block;
    margin-right: 6px;
    color: #ff4d00;
   }

  .quick-grid {
    margin-top: auto;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px 6px;
    justify-items: center;
  }

  .quick-grid button {
    width: 52px;
    height: 46px;
    border: 0;
    color: #0f172a;
    font-size: 12px;
    border-radius: 0;
    background: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    cursor: pointer;
  }

  .quick-grid button span {
    white-space: nowrap;
    line-height: 16px;
  }

  .quick-grid img {
    width: 24px;
    height: 24px;
  }

  .brand-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    margin-top: 14px;
    padding: 14px;
    border-radius: 8px;
    background: #fff;
  }

  .hot-section,
  .info-card {
    margin-top: 14px;
    border-radius: 8px;
    background: #fff;
    overflow: hidden;
  }

  .home-section-title {
    height: 58px;
    padding: 0 18px;
    border-bottom: 1px solid #edf0f4;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .home-section-title div,
  .home-section-title.compact {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .home-section-title h2 {
    margin: 0;
    color: #111827;
    font-size: 22px;
  }

  .home-section-title span {
    color: #d12626;
    font-size: 13px;
  }

  .home-section-title a {
    color: #8a8f99;
    font-size: 13px;
  }

  .hot-content {
    display: grid;
    grid-template-columns: 1fr 304px;
    gap: 28px;
    padding: 18px 14px 16px;
  }

  .hot-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 62px;
    align-content: start;
  }

  .hot-item {
    display: grid;
    grid-template-columns: 26px 1fr;
    align-items: center;
    min-width: 0;
    color: #333;
    font-size: 14px;
    cursor: pointer;
  }

  .hot-item span {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    text-align: center;
    line-height: 22px;
    color: #fff;
    font-size: 12px;
  }

  .hot-item .fire {
    background: #ff4a2b;
  }

  .hot-item b,
  .hot-item em {
    display: block;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-style: normal;
  }

  .hot-item b {
    color: #d12626;
  }

  .hot-product-info { min-width: 0; padding: 6px 0; }
  .hot-product-info small { display: block; color: #667085; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

  .inquiry-card {
    padding: 20px 30px;
    border-radius: 12px;
    background: linear-gradient(180deg, #dbeeff, #f6fbff);
    box-shadow: 0 8px 22px rgba(22, 132, 255, .13);
  }

  .inquiry-head {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 18px;
  }

  .inquiry-icon {
    width: 48px;
    height: 48px;
    border-radius: 13px;
    background: #1684ff;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(-14deg);
  }

  .inquiry-icon img {
    width: 28px;
    height: 28px;
    filter: brightness(0) invert(1);
  }

  .inquiry-head strong,
  .inquiry-head span {
    display: block;
  }

  .inquiry-head strong {
    color: #111827;
    font-size: 24px;
  }

  .inquiry-head span {
    margin-top: 4px;
    color: #666;
  }

  .inquiry-card input {
    width: 100%;
    height: 44px;
    margin-bottom: 12px;
    padding: 0 12px;
    border: 0;
    border-radius: 4px;
    background: #edf6ff;
    box-sizing: border-box;
    outline: 0;
  }

  .inquiry-card button {
    width: 100%;
    height: 44px;
    margin-top: 2px;
    border: 0;
    border-radius: 22px;
    background: #1684ff;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
  }

  .info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
  }

  .info-body {
    display: grid;
    grid-template-columns: 266px 1fr;
    gap: 20px;
    padding: 16px;
  }

  .feature-news {
    cursor: pointer;
    min-width: 0;
  }

  .feature-news img {
    width: 100%;
    height: 198px;
    border-radius: 8px;
    object-fit: cover;
    background: #f3f4f6;
  }

  .feature-news h3 {
    margin: 12px 0 8px;
    color: #222;
    font-size: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .feature-news p {
    margin: 0;
    color: #667085;
    line-height: 22px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .rank-list {
    margin: 0;
    padding: 0;
    list-style: none;
    min-width: 0;
  }

  .rank-list li {
    height: 38px;
    display: grid;
    grid-template-columns: 24px 1fr;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    min-width: 0;
  }

  .rank-list span {
    color: #d12626;
    font-weight: 700;
  }

  .rank-list b {
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #344054;
    font-size: 14px;
    font-weight: 400;
  }

  .video-list li {
    grid-template-columns: 24px 1fr 34px;
  }

  .video-list button {
    width: 32px;
    height: 22px;
    border: 1px solid #d5dae3;
    background: #fff;
    color: #64748b;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .video-list button img {
    width: 13px;
    height: 13px;
  }

  .section-head {
    height: 36px;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .section-head h2 {
    margin: 0 14px 0 0;
    font-size: 20px;
  }

  .section-head span {
    padding: 4px 10px;
    background: #f3f6fb;
    color: #506176;
    font-size: 12px;
  }

  .brand-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
  }

  .brand-card {
    height: 104px;
    border-radius: 8px;
    background: linear-gradient(135deg, #14213d, #1684ff);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 800;
  }
</style>

